export class ProfileProgressType {
  static UNDEFINED = -1;
  static RANGE = 1;
}
